import { atom } from 'jotai';

export type ToastSeverity = 'error' | 'success' | 'warning' | 'info';

export interface Toast {
  id: string;
  severity: ToastSeverity;
  title: string;
  message: string;
  createdAt: number;
}

const toastsAtom = atom<Toast[]>([]);

export { toastsAtom };
